import { Component, Input } from '@angular/core';
import { Beneficio } from '../detalhamento';

@Component({
  selector: 'store-beneficios',
  templateUrl: './beneficios.component.html',
  styleUrls: ['./beneficios.component.scss']
})
export class BeneficiosComponent {

  @Input()
  public beneficios: Beneficio[];

  @Input()
  public produto: string;

  @Input()
  public imagem: string;

}
